import React, { useContext, useEffect, useRef } from 'react'
import { Button, ButtonGroup, Paper, Portal, makeStyles, useDynamicObservable } from '@cicero/ui'
import { of } from 'rxjs'
import { map } from 'rxjs/operators'
import { ReactEditor } from 'slate-react'
import { EditorContext, EditorService, IEditorCommand } from '../EditorService'
import { UserSchema, useModel } from 'models'
import { ContentCommands } from '../commands'

export const CommandPallette = () => {
  const { menu } = styles()
  const ref = useRef<HTMLElement>(null)
  const User = useModel(UserSchema)
  const [commands, setCommandsObservable] = useDynamicObservable<IEditorCommand[]>([])
  const service = useContext(EditorContext)

  useEffect(() => {
    const sub = service.state.currentPhrase$.subscribe(phrase => {
      const el = ref.current
      if (!el) { return }

      if (phrase === null) {
        setCommandsObservable(of([]))
        el.removeAttribute('style') // Hide element
        return
      }

      const search  = phrase.slice(1)
      const domSelection = window.getSelection()
      const domRange = domSelection?.getRangeAt(0)
      const rect = domRange?.getBoundingClientRect()
      el.style.opacity = '1'
      el.style.top = `${(rect?.top || 0) + window.pageYOffset + el.offsetHeight}px`
      el.style.left = `${(rect?.left || 0) + window.pageXOffset}px`

      switch(phrase[0]) {
        case '@':
          setCommandsObservable(
            User.QUERY$({ selector: {} }).pipe(map(users => users.map(user => {
              return {
                title: UserSchema.getNameString(user),
                handler: (editor: ReactEditor, s: EditorService) => ContentCommands.addMention(user, s),
              }
            })))
          )
          break

        case '/':
          setCommandsObservable(of(service.renderCommandList({ search })))
          break

        default:
          // console.log(phrase)
      }
    })

    return () => sub.unsubscribe()
  }, [service])

  return <Portal>
    <Paper ref={ref} className={menu}>
      <ButtonGroup orientation="vertical">
        { commands
          .map((cmd, i) =>
            <Button
              key={i}
              onMouseDown={(e) => {
                e.preventDefault()
                // Transforms.removeNodes(service.editor, { at: target })
                // setTarget(null)
                cmd.handler(service.editor, service)
              }}>{cmd.title}</Button>
          )
        }
      </ButtonGroup>
    </Paper>
  </Portal>
}

const styles = makeStyles({
  menu: {
    opacity: 0,
    position: 'absolute',
    zIndex: 1,
    transition: 'all ease-in-out .5s',
  },
})
